
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import LoadRow from "@/views/load/LoadRow.vue";
import LoadAdd from "@/views/load/LoadAdd.vue";
import { Load } from "@/store/load/model/load";

@Component({
  components: {
    LoadRow,
    LoadAdd,
  },
  props: {
    corpType: {
      default: null,
    },
    shouldReload: {
      default: null,
    },
  },
})
export default class Loads extends Vue {
  rows1: Load[] = [];
  grid = { page: 0, rows: this.rows1 };
  rows = 20;
  url = "/api/load/grid?sidx=createdAt&sord=desc&rows=" + this.rows;
  url_sup =
    "/api/load/supplier/grid?sidx=createdAt&sord=desc&rows=" + this.rows;
  showFilter = false;
  name = "";
  menu1 = false;
  filterUrl = "";
  country = "";
  city = "";
  on = null;
  page = 1;
  state = "";
  shortCode = "";
  showGrid = true;
  load_id = null;

  get loading() {
    return common.loading;
  }

  @Watch("shouldReload")
  onshouldReload(val) {
    if (val) {
      this.search();
    }
  }

  select(data) {
    this.$emit("select", data);
    this.showGrid = true;
    this.clear();
  }

  async mounted() {
    common.setLoading(true);
    try {
      if (this.$props.corpType == 2) this.grid = await doGet(this.url);
      else if (this.$props.corpType == 3) this.grid = await doGet(this.url_sup);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async showPage(page) {
    this.page = page;
    const url = this.$props.corpType == 2 ? this.url : this.url_sup;
    this.grid = await doGet(url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.name = "";
    this.shortCode = "";
    this.country = "";
    this.state = "";
    this.city = "";
    this.page = 1;
    this.search();
  }

  async search() {
    this.filterUrl = "";
    if (this.name) this.filterUrl += "&name=" + this.name;
    if (this.shortCode) this.filterUrl += "&shortCode=" + this.shortCode;
    if (this.country) this.filterUrl += "&country=" + this.country;
    if (this.state) this.filterUrl += "&state=" + this.state;
    if (this.city) this.filterUrl += "&city=" + this.city;
    common.setLoading(true);
    await this.showPage(1);
  }

  async deletebu(bu) {
    try {
      await doGet("/api/load/" + bu._id + "/delete");
      common.showMessage("Deleted Successfully");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }
}
